// External
import React from 'react';

// Internal
import {
  ExpandedValuePropsContainer,
  ExpandedValuePropsRow,
  ExpandedValuePropsText,
  PurchaseProtectionV2ContentContainer,
  PurchaseProtectionV2IconContainer,
} from '@/components/CheckoutIncentives/StyledComponents';
import { ShieldCheckSpot, ShieldEmptySpot } from '@/components/Common';
import { features, getContent, useMountLogging } from '@/lib';
import { useStoreState } from '@/store';
import { CountryCodes } from '@/generated/graphql';

type PurchaseProtectionParams = {
  /** Optional, as we use this component for forced signup as well. */
  toggleComponent?: JSX.Element;
};

const PurchaseProtectionV2 = ({
  toggleComponent,
}: PurchaseProtectionParams): JSX.Element => {
  useMountLogging('PurchaseProtectionV2');
  const isOptionalSignup = features.isActive('isOptionalSignup');
  const isForcedSignup = features.isActive('isForcedSignUp');
  const onboardValue = useStoreState(({ form }) => form.onboardOption?.value);

  // Default to forced signup content.
  let purchaseProtectionContent =
    'checkoutIncentives.purchaseProtection.forced.signup.description';
  // User is optional signup
  const isGuestToggle = Boolean(onboardValue === 'guest');

  if (isOptionalSignup) {
    // Optional. Swap content based on state of onboard switch.
    purchaseProtectionContent = isGuestToggle
      ? 'checkoutIncentives.purchaseProtection.optional.guest.description'
      : 'checkoutIncentives.purchaseProtection.optional.signup.description';
  }

  return (
    <ExpandedValuePropsContainer data-testid="purchase-protection">
      <ExpandedValuePropsRow>
        <PurchaseProtectionV2IconContainer>
          {isGuestToggle && !isForcedSignup ? (
            <ShieldEmptySpot />
          ) : (
            <ShieldCheckSpot />
          )}
        </PurchaseProtectionV2IconContainer>
        <PurchaseProtectionV2ContentContainer>
          <ExpandedValuePropsText>
            {getContent(
              purchaseProtectionContent,
              { country: CountryCodes.Us },
              { useHTML: true },
            )}
          </ExpandedValuePropsText>
        </PurchaseProtectionV2ContentContainer>
        {isOptionalSignup && toggleComponent}
      </ExpandedValuePropsRow>
    </ExpandedValuePropsContainer>
  );
};

export { PurchaseProtectionV2 };
